import React from "react";
import { useParams } from "react-router-dom";


const CurrencyConverter = () => {

  return (
    <div className="utils-home">
        <iframe height="410" width="220" src="https://ssltools.investing.com/currency-converter/?from=17&to=12&force_lang=1&with_powered_by=true"></iframe>
    </div>
  );
};

export default CurrencyConverter;